// src/lib/services/push.ts
// Push subscription upkeep through ladders-public (service role writes; RLS lets a player read/delete their own).
import { invokeEdgeFunction } from "@/lib/supabase-client";

type SubJson = { endpoint: string; keys: { p256dh: string; auth: string } };
const pushAction = <T>(action: string, payload: Record<string, unknown>) =>
  invokeEdgeFunction<T>("ladders-public", { resource: "push", action, ...payload }, false);

export const savePushSubscription = (sub: SubJson) =>
  pushAction<{ ok: true }>("subscribe", { ...sub, userAgent: typeof navigator === "undefined" ? null : navigator.userAgent });
export const removePushSubscription = (endpoint: string) => pushAction<{ ok: true }>("unsubscribe", { endpoint });
export const pingStandalone = (standalone: boolean) => pushAction<{ ok: true }>("ping", { standalone });
